import type { IconSmallProps } from './base';
import { BaseIcon } from './base';

export function IconInfoSimple(props: IconSmallProps) {
  return (
    <BaseIcon {...props}>
      <path
        fillRule="evenodd"
        d="M11.5 7a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM10 9a1 1 0 0 0 0 2h1v8a1 1 0 1 0 2 0V9h-3Z"
        clipRule="evenodd"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
